import React from 'react';
import { MapPin, Mail, Phone } from 'lucide-react';

const Footer = ({ contactmail, contactphone, contactlocation, mailIcon, phoneIcon, locationIcon }) => {
  return (
    <footer className="bg-dark-900 text-white pt-16 pb-8 border-t border-dark-800">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold text-accent uppercase tracking-wider">About Us</h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              Hanuman Global Exports and Imports is a leading exporter of premium agricultural products with decades of experience in international trade.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold text-accent uppercase tracking-wider">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              {['Home', 'About', 'Products', 'Certifications', 'Operations', 'Contact'].map(
                (link) => (
                  <li key={link}>
                    <a
                      href="/"
                      className="text-gray-300 hover:text-accent transition-colors duration-200"
                    >
                      {link}
                    </a>
                  </li>
                )
              )}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold text-accent uppercase tracking-wider">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3 text-sm">
                <MapPin size={20} className="text-accent flex-shrink-0 mt-0.5" />
                <span className="text-gray-300">Hyderabad, India</span>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <Phone size={20} className="text-accent flex-shrink-0" />
                <a
                  href="tel:+919876543210"
                  className="text-gray-300 hover:text-accent transition-colors"
                >
                  +91 98765 43210
                </a>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <Mail size={20} className="text-accent flex-shrink-0" />
                <a
                  href="mailto:info@hanumanexports.com"
                  className="text-gray-300 hover:text-accent transition-colors"
                >
                  info@hanumanexports.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-dark-800 pt-8">
          {/* Social Links (if needed) */}
          <div className="flex justify-center gap-6 mb-6">
            {/* Social icons can be added here */}
          </div>

          {/* Copyright */}
          <div className="text-center text-sm text-gray-400">
            <p>&copy; 2024 Hanuman Global Exports and Imports. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
